import type { RoLiveWorkPresentation } from "@shared/roRunningPresentation";

export function RoLiveWorkMark({ live }: { live: RoLiveWorkPresentation }) {
  if (!live.active || !live.stageId) return null;
  return (
    <span
      data-testid="ro-stage-live"
      data-live-stage={live.stageId}
      className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800"
    >
      <span className="relative flex h-2 w-2" aria-hidden>
        <span className="absolute inline-flex h-full w-full rounded-full bg-amber-400 motion-safe:animate-ping motion-reduce:hidden" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500" />
      </span>
      Live
    </span>
  );
}

export function RoWorkRecordedState({
  live,
  recordedLabel,
  technicianName,
  startedLabel,
}: {
  live: RoLiveWorkPresentation;
  recordedLabel: string;
  technicianName?: string | null;
  startedLabel?: string | null;
}) {
  if (!live.active) {
    return <span data-testid="ro-work-recorded" className="text-right font-medium text-slate-900">{recordedLabel}</span>;
  }
  return (
    <span data-testid="ro-work-recorded" className="text-right">
      <span data-testid="ro-work-active" className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-semibold text-amber-800">
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500 motion-safe:animate-pulse" aria-hidden />
        In progress
      </span>
      {technicianName || startedLabel ? (
        <span data-testid="ro-work-active-meta" className="mt-1 block text-xs font-normal text-slate-500">
          {[technicianName, startedLabel ? `started ${startedLabel}` : null].filter(Boolean).join(" · ")}
        </span>
      ) : null}
    </span>
  );
}
